(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-help-center"] && !Shopify.designMode) return;
  try {
    class FaqHelpCenter extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.source = this.querySelector('[data-faq-source]');
      this.searchInput = this.querySelector('[data-faq-search]');
      this.clearButton = this.querySelector('[data-faq-clear]');
      this.resetButton = this.querySelector('[data-faq-reset]');
      this.categoryNav = this.querySelector('[data-faq-categories]');
      this.categorySelect = this.querySelector('[data-faq-category-select]');
      this.categorySelectWrapper = this.querySelector('[data-faq-category-select-wrapper]');
      this.count = this.querySelector('[data-faq-count]');
      this.empty = this.querySelector('[data-faq-empty]');

      if (!this.source || !this.searchInput || !this.categoryNav || !this.categorySelect) return;

      this.dataset.initialized = 'true';
      this.activeCategory = 'all';
      this.categories = this.buildAccordion();

      if (!this.categories.length) return;

      this.buildCategoryNavigation();
      this.searchInput.disabled = false;
      this.searchInput.addEventListener('input', () => this.applyFilters());
      this.clearButton?.addEventListener('click', () => this.clearSearch());
      this.resetButton?.addEventListener('click', () => this.resetFilters());
      this.applyFilters();
    }

    slugify(value, index) {
      const slug = value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

      return slug || `category-${index + 1}`;
    }

    buildAccordion() {
      const nodes = Array.from(this.source.children);
      const parsed = [];
      let currentCategory = null;
      let currentQuestion = null;

      nodes.forEach((node) => {
        if (node.tagName === 'H2') {
          currentCategory = {
            title: node.textContent.trim(),
            questions: [],
            looseNodes: [],
          };
          parsed.push(currentCategory);
          currentQuestion = null;
          return;
        }

        if (node.tagName === 'H3') {
          if (!currentCategory) {
            currentCategory = {
              title: this.categoryNav.dataset.allLabel,
              questions: [],
              looseNodes: [],
            };
            parsed.push(currentCategory);
          }

          currentQuestion = {
            title: node.textContent.trim(),
            answerNodes: [],
          };
          currentCategory.questions.push(currentQuestion);
          return;
        }

        if (currentQuestion) {
          currentQuestion.answerNodes.push(node);
        } else if (currentCategory) {
          currentCategory.looseNodes.push(node);
        }
      });

      const fragment = document.createDocumentFragment();
      const categories = [];

      parsed.forEach((category, categoryIndex) => {
        if (!category.questions.length) {
          return;
        }

        const slug = this.slugify(category.title, categoryIndex);
        const categoryElement = document.createElement('section');
        categoryElement.className = 'faq-hub__category';
        categoryElement.dataset.faqCategory = slug;

        const heading = document.createElement('h2');
        heading.className = 'faq-hub__category-title';
        heading.textContent = category.title;
        categoryElement.append(heading);

        if (category.looseNodes.length) {
          const note = document.createElement('div');
          note.className = 'faq-hub__category-note';
          category.looseNodes.forEach((node) => note.append(node.cloneNode(true)));
          categoryElement.append(note);
        }

        const accordion = document.createElement('div');
        accordion.className = 'faq-hub__accordion';
        const entries = [];

        category.questions.forEach((question) => {
          const details = document.createElement('details');
          details.className = 'faq-hub__item';

          const summary = document.createElement('summary');
          summary.className = 'faq-hub__question';

          const questionText = document.createElement('span');
          questionText.className = 'faq-hub__question-text';
          questionText.textContent = question.title;

          const questionIcon = document.createElement('span');
          questionIcon.className = 'faq-hub__question-icon';
          questionIcon.setAttribute('aria-hidden', 'true');

          const answer = document.createElement('div');
          answer.className = 'faq-hub__answer';
          question.answerNodes.forEach((node) => answer.append(node.cloneNode(true)));

          summary.append(questionText, questionIcon);
          details.append(summary, answer);
          accordion.append(details);

          entries.push({
            element: details,
            searchText: `${question.title} ${answer.textContent}`.toLowerCase(),
          });
        });

        categoryElement.append(accordion);
        fragment.append(categoryElement);
        categories.push({
          title: category.title,
          slug,
          element: categoryElement,
          entries,
        });
      });

      this.source.replaceChildren(fragment);
      this.source.classList.add('faq-hub__results');

      return categories;
    }

    buildCategoryNavigation() {
      const buttons = [];
      const allButton = this.createCategoryButton(this.categoryNav.dataset.allLabel, 'all');
      const allOption = new Option(this.categoryNav.dataset.allLabel, 'all', true, true);
      this.categoryNav.append(allButton);
      this.categorySelect.append(allOption);
      buttons.push(allButton);

      this.categories.forEach((category) => {
        const button = this.createCategoryButton(category.title, category.slug);
        const option = new Option(category.title, category.slug);
        this.categoryNav.append(button);
        this.categorySelect.append(option);
        buttons.push(button);
      });

      this.categoryButtons = buttons;
      this.categoryNav.hidden = false;
      this.categorySelect.disabled = false;
      this.categorySelectWrapper.hidden = false;
      this.categorySelect.addEventListener('change', () => this.setCategory(this.categorySelect.value));
    }

    createCategoryButton(label, value) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'faq-hub__category-button';
      button.textContent = label;
      button.dataset.category = value;
      button.setAttribute('aria-pressed', value === this.activeCategory ? 'true' : 'false');
      button.addEventListener('click', () => this.setCategory(value));

      return button;
    }

    setCategory(value) {
      this.activeCategory = value;
      this.applyFilters();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.source?.animate(
          [{ opacity: 0.85 }, { opacity: 1 }],
          { duration: 120, easing: 'ease-out' }
        );
      }
    }

    applyFilters() {
      const rawQuery = this.searchInput.value.trim();
      const query = rawQuery.toLowerCase();
      let visibleCount = 0;

      this.categories.forEach((category) => {
        const categorySelected = this.activeCategory === 'all' || this.activeCategory === category.slug;
        let categoryCount = 0;

        category.entries.forEach((entry) => {
          const queryMatches = !query || entry.searchText.includes(query);
          const visible = categorySelected && queryMatches;
          entry.element.hidden = !visible;

          if (visible) {
            categoryCount += 1;
            visibleCount += 1;
          }
        });

        category.element.hidden = categoryCount === 0;
      });

      this.categoryButtons?.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.category === this.activeCategory ? 'true' : 'false');
      });

      if (this.categorySelect) {
        this.categorySelect.value = this.activeCategory;
      }

      if (this.count) {
        const label = visibleCount === 1 ? this.count.dataset.one : this.count.dataset.other;
        const resultLabel = label.replace('[count]', visibleCount);
        this.count.textContent = rawQuery ? `${resultLabel} · “${rawQuery}”` : resultLabel;
      }

      if (this.empty) {
        this.empty.hidden = visibleCount !== 0;
      }

      if (this.clearButton) {
        this.clearButton.hidden = query.length === 0;
      }
    }

    resetFilters() {
      this.searchInput.value = '';
      this.activeCategory = 'all';
      this.applyFilters();
      this.searchInput.focus();
    }

    clearSearch() {
      this.searchInput.value = '';
      this.applyFilters();
      this.searchInput.focus();
    }
  }

  if (!customElements.get('faq-help-center')) {
    customElements.define('faq-help-center', FaqHelpCenter);
  }
  } catch(e) { console.error(e); }
})();

})();
